import { PageId } from 'constants/pages'

export const enum PageIdStylioHusap {
  AGE_HUSAP = PageId.AGE_HUSAP,
  SHOP_SMARTER_HUSAP = PageId.SHOP_SMARTER_HUSAP,
  STYLIO_TO_HELP_HUSAP = PageId.STYLIO_TO_HELP_HUSAP,
  MAIN_GOAL_HUSAP = PageId.MAIN_GOAL_HUSAP,
  WHERE_TO_SHOP_HUSAP = PageId.WHERE_TO_SHOP_HUSAP,
  WARDROBE_PERCENTAGE_HUSAP = PageId.WARDROBE_PERCENTAGE_HUSAP,
  HAIR_COLOR_HUSAP = PageId.HAIR_COLOR_HUSAP,
  EYES_COLOR_HUSAP = PageId.EYES_COLOR_HUSAP,
  SKIN_COLOR_HUSAP = PageId.SKIN_COLOR_HUSAP,
  CLIMAT_HUSAP = PageId.CLIMAT_HUSAP,
  BODY_SHAPE_HUSAP = PageId.BODY_SHAPE_HUSAP,
  URGE_2_HUSAP = PageId.URGE_2_HUSAP,
  URGE_3_HUSAP = PageId.URGE_3_HUSAP,
  URGE_4_HUSAP = PageId.URGE_4_HUSAP,
  URGE_7_HUSAP = PageId.URGE_7_HUSAP,
  URGE_8_HUSAP = PageId.URGE_8_HUSAP,
  URGE_9_HUSAP = PageId.URGE_9_HUSAP,
  NOTHING_TO_WEAR_HUSAP = PageId.NOTHING_TO_WEAR_HUSAP,
  ARCHETYPE_INTRO_HUSAP = PageId.ARCHETYPE_INTRO_HUSAP,
  LOOKING_FEMININE_HUSAP = PageId.LOOKING_FEMININE_HUSAP,
  STYLES_FEEL_LIKE_YOU_HUSAP = PageId.STYLES_FEEL_LIKE_YOU_HUSAP,
  TALL_HUSAP = PageId.TALL_HUSAP,
  WEIGHT_HUSAP = PageId.WEIGHT_HUSAP,
  WARDROBE_CHANGED_HUSAP = PageId.WARDROBE_CHANGED_HUSAP,
  FAVORITE_COLORS_HUSAP = PageId.FAVORITE_COLORS_HUSAP,
  LIKE_OR_DISLIKE_11_HUSAP = PageId.LIKE_OR_DISLIKE_11_HUSAP,
  LIKE_OR_DISLIKE_14_HUSAP = PageId.LIKE_OR_DISLIKE_14_HUSAP,
  LIKE_OR_DISLIKE_15_HUSAP = PageId.LIKE_OR_DISLIKE_15_HUSAP,
  LIKE_OR_DISLIKE_18_HUSAP = PageId.LIKE_OR_DISLIKE_18_HUSAP,
  LIKE_OR_DISLIKE_19_HUSAP = PageId.LIKE_OR_DISLIKE_19_HUSAP,
  WALK_INTO_ROOM_HUSAP = PageId.WALK_INTO_ROOM_HUSAP,
  PERFECT_WEEKEND_HUSAP = PageId.PERFECT_WEEKEND_HUSAP,
  LIFESTYLE_FOCUS_HUSAP = PageId.LIFESTYLE_FOCUS_HUSAP,
  OUTFIT_NEEDS_HUSAP = PageId.OUTFIT_NEEDS_HUSAP,
  WARDROBE_ALIGNS_HUSAP = PageId.WARDROBE_ALIGNS_HUSAP,
  STYLE_DRAWN_TO_HUSAP = PageId.STYLE_DRAWN_TO_HUSAP,
  OUTFIT_EMOTION_HUSAP = PageId.OUTFIT_EMOTION_HUSAP,
  WARDROBE_COLORS_HUSAP = PageId.WARDROBE_COLORS_HUSAP,
  PREPARE_FLOW_HUSAP = PageId.PREPARE_FLOW_HUSAP,
  EMAIL_HUSAP = PageId.EMAIL_HUSAP,
  EMAIL_CONSENT_HUSAP = PageId.EMAIL_CONSENT_HUSAP,
  SUBSCRIPTIONS_HUSAP = PageId.SUBSCRIPTIONS_HUSAP,
  CANCEL_OFFER_HUSAP = PageId.CANCEL_OFFER_HUSAP,
  AI_STYLIST_UPSELL_HUSAP = PageId.AI_STYLIST_UPSELL_HUSAP,
  FACE_STYLING_PDF_UPSELL_HUSAP = PageId.FACE_STYLING_PDF_UPSELL_HUSAP,
  PROPORTIONS_PDF_UPSELL_HUSAP = PageId.PROPORTIONS_PDF_UPSELL_HUSAP,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_HUSAP = PageId.DOWNLOAD_HUSAP,
}
